
import TsEventEmitter from 'ts-eventemitter';

export class MtEventSource<T> implements TsEventEmitter {

    static EVT_MAP_IDLE = "onMapIdle";
    static EVT_MAP_CLICK = "onMapClick";
    static EVT_MAP_ZOOM_CHANGED = "onZoomChanged";
    static EVT_MAP_MARKER_CLICK = "onMarkerClick";

    private eventDispatcher: TsEventEmitter;

    constructor() {
        this.eventDispatcher = TsEventEmitter.create();
    }

    event(name: string): TsEventEmitter.Event1<this, T> {
        return (this.eventDispatcher.event(name) as TsEventEmitter.Event1<this, T>);
    }

    removeAllListeners(): void {
        this.eventDispatcher.removeAllListeners();
    }

    setMaxListeners(n: number): void {
        this.eventDispatcher.setMaxListeners(n);
    }
}





// WEBPACK FOOTER //
// ./src/mteventsource.ts